import { useEffect, useRef } from 'react';

/** Code128 en SVG, client-side (ADR-0006). Barras ≥12mm de alto para el mostrador. */
export function CodigoBarras({ valor, alto = 46 }: { valor: string; alto?: number }) {
  const ref = useRef<SVGSVGElement>(null);
  useEffect(() => {
    // jsbarcode se carga al usarse: solo lo necesitan las etiquetas, no el arranque.
    let montado = true;
    void import('jsbarcode').then(({ default: JsBarcode }) => {
      if (!montado || !ref.current) return;
      try {
        JsBarcode(ref.current, valor, {
          format: 'CODE128',
          height: alto,
          width: 1.6,
          margin: 4,
          displayValue: false,
          background: 'transparent',
          // Negro puro y no un token de tema: el lector necesita el contraste máximo, y en tema
          // oscuro un color de texto claro dejaría el código ilegible para el escáner.
          lineColor: '#000000',
        });
      } catch {
        /* valor no codificable: se muestra vacío */
      }
    });
    return () => {
      montado = false;
    };
  }, [valor, alto]);
  return <svg ref={ref} role="img" aria-label={`Código de barras ${valor}`} />;
}
